// jQuery_T4NT(document).ready(function($) {

//      /**
//      * Variant selection changed
//      */
// 	  $( document ).on( "variant:change", function( evt, variant ) {
// 	    //console.log( variant );
// 	  });

// });

function calculate()
{

 // var email = $('#email').val();
  var gender = $('input[name="gender"]:checked').val();
  var age = $('#age').val();
  var weight = $('#weight').val();
  var height = $('#height').val();
  var activity = $('#activity').val();
  var target_based = $('#target_based').val();
  
  var activity = $('#activity').val();
    
  if(gender=='Male')
  {
    var BMR = 66 + (13.75 * weight) + (5 * height) - (6.8 * age);
  }
  else if(gender=='Famale')
  {
    var BMR = 655 + (9.6 * weight) + (1.8 * height) - (4.7 * age);
  }
  else
  {
    $('#bmr_erorr_div').html('Please choose gender'); 
    return false;
  } 
  
  if(age=='')
  {
    $('#bmr_erorr_div').html('Please enter age'); 
    return false;
  }
  
  if(weight=='')
  {
	$('#bmr_erorr_div').html('Please enter weight');  
    return false;
  }
  
  if(height=='')
  {
    $('#bmr_erorr_div').html('Please enter height');   
    return false;
  }
  
  if(document.getElementById('breastfeeding').checked) 
  {
     
  } 
  else 
  {
     
  }

  //  Final_BMR = Math.round(BMR * 100) / 100;
  Final_BMR = Math.round(BMR);
  bmr_output_daily_need = Math.round(Final_BMR * activity); 
  
  
  if(document.getElementById('breastfeeding').checked) 
  {
     Final_output_daily_need = bmr_output_daily_need + 500;
  } 
  else 
  {
     Final_output_daily_need = bmr_output_daily_need ;
  }
  
  $('#bmr_result').show();
  $('#bmr_erorr_div').html(' ');
  $('#bmr_result_bmt').html(Final_BMR);
  $('#bmr_output_daily_need').html(Final_output_daily_need);
  
  var target_to_lost = Math.round(Final_output_daily_need * target_based);
  var final_target_to_lost =  Math.round(Final_output_daily_need - target_to_lost);
  $('#target_to_lose').html(final_target_to_lost);
   
  
  

//   if(IsEmail(email)==false)
//   {
// 	alert('Please enter valid email');
// 	return false;
//   }
  

// 	$.ajax({
// 			type: "POST",
// 			url: "/mail-sent.php",
// 			data: {email:email, gender:gender, age:age, weight:weight, height:height, activity:activity, goal:goal},
// 			dataType: "json",
// 			success : function(data)
// 			  {

// 				if(data.code == "200"){
// 					alert("Email sent.");
// 				} else {
// 					alert('Could not send mail! Sorry!');
// 				}
// 			}
// 		});


  
  //$("#bmr_output_result_loss").html(loss);
  //$("#bmr_output_result_maintain").html(maintain);
}

// function IsEmail(email) {
//   var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
//   if(!regex.test(email)) {
// 	return false;
//   }else{
// 	return true;
//   }
// }
